import dataType from '../dataType';

const annaDsbUpi = {
    name: 'AnnaDsbUpi',
    type: dataType.string
};

export default annaDsbUpi;
